import PreferencesService from "../../services/PreferencesService";
import storageService from "../../services/StorageService";

var preference = {
    state: () => ({
        currency: 'CAD',
        userPreferences: {
            scoreCalculation: {
                buyList: {
                    distribution: [],
                    fallbackStrategyName: undefined
                }
            }
        }
    }),
    mutations: {
        setUserCurrency(state, { currency }) {
            state.currency = currency
        },
        setUserPreferences(state, { userPreferences }) {
            state.userPreferences = userPreferences
        },
        setScoreCalculationBuyListInfos(state, { distribution, fallbackStrategyName }) {
            state.userPreferences.scoreCalculation.buyList.distribution = distribution;
            state.userPreferences.scoreCalculation.buyList.fallbackStrategyName = fallbackStrategyName;
        }
    },
    actions: {
        initPreferences({ commit }) {
            this.preferencesService = new PreferencesService();
            this.preferencesService.getUserPreferences().then(response => {
                commit('setUserPreferences', { userPreferences: response });
            })
            .catch(error => {
                console.error(error);
            });
            const currency = storageService.userCurrency || 'CAD'
            commit('setUserCurrency', { currency })
        },
        setUserCurrency(context, { currency }) {
            storageService.userCurrency = currency
            context.commit('setUserCurrency', { currency })
        },
        addOrUpdateScoreCalculationBuyListInfos({ commit, state }, { distribution, fallbackStrategyName }) {
            return new Promise((resolve, reject) => {
                commit('setScoreCalculationBuyListInfos', { distribution, fallbackStrategyName });
                this.preferencesService = new PreferencesService();
                this.preferencesService.addOrUpdate({ userPreference: state.userPreferences })
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        }
    },
    getters: {
        userCurrency(state) {
            return state.currency
        },
        conversionCurrency(state) {
            return state.currency === 'CAD' ? 'USD' : 'CAD'
        },
        getDefaultConversion(state) {
            const conversionCurrency = state.currency === 'CAD' ? 'USD' : 'CAD'
            return `${conversionCurrency},${state.currency}`.toUpperCase()
        },
        getUserPreferences(state) {
            return state.userPreferences;
        },
        getScoreCalculationBuyListInfos(state) {
            return state.userPreferences.scoreCalculation.buyList;
        }
    }
}

export default preference;